import { MetaFunction } from '@remix-run/node'

import { Breadcrumb, Container } from '~/components'
import { TopFooter, TopHeader, FaqPage } from '~/features'

export const meta: MetaFunction = ({ matches }) => {
  const parentMeta = matches
    .flatMap((match) => match.meta ?? [])
    .filter((meta) => !('title' in meta))
  return [
    ...parentMeta,
    { title: 'よくある質問 | シェアオフィス コワーキングスペース検索サイト' },
  ]
}

export default function Faq() {
  return (
    <>
      <TopHeader />
      <Container className="pt-14">
        <Breadcrumb
          links={[{ href: '/', text: 'トップ' }, { text: 'よくある質問' }]}
        />
      </Container>
      <FaqPage />
      <TopFooter />
    </>
  )
}
